import React from 'react';
import styles from './loadingIndicator.module.css';
import LoadingImage from '../../assets/images/toppy-loading.gif';

const LoadingIndicator = () => {
    return (
        <div className={styles.overlay}>
            <div
                className={styles.indicator}
                style={{backgroundImage: `url(${LoadingImage})`}}
            />
        </div>
    );
};

export default LoadingIndicator;
